<template>
  <div id="top-panel" class="top-info flex justify-content-around" v-if="customerInfo && customerInfo.id">
    <div class="flex flex-column">
      <div class="flex">
        <div class="top-info-item top-info-personal flex-fill border border-light" style="padding-bottom: 0;">
          <div class="top-info-line">
            <h3>
              {{ customerInfo.full_name }}
            </h3>
          </div>
          <div class="top-info-line flex flex-wrap">
            <strong>Age: </strong>
            <div class="margin-left-auto">
              {{ customerInfo.age }}
            </div>
          </div>

          <div class="top-info-line flex flex-wrap">
            <strong>Height: </strong>
            <div class="margin-left-auto">
              {{ customerInfo.height }}
            </div>
          </div>

          <div class="top-info-line flex flex-wrap">
            <strong>
              Hair:
            </strong>
            <div class="margin-left-auto">
              {{ customerInfo.hair_color }}
            </div>
          </div>

          <div class="top-info-line flex flex-wrap">
            <strong>Skin: </strong>
            <div class="margin-left-auto">
              {{ customerInfo.skin_color }}
            </div>
          </div>

          <div class="top-info-line flex flex-wrap">
            <strong>ID: </strong>
            <div class="margin-left-auto">
              <u>
                <router-link :to="{ path: `/customer/${customerInfo.id}` }">
                  {{ customerInfo.id }}
                </router-link>
              </u>
            </div>
          </div>

          <div class="top-info-line flex flex-wrap">
            <strong>Phone: </strong>
            <div class="margin-left-auto">
              <a :href="`tel:${customerInfo.phone}`">{{ customerInfo.phone }}</a>
            </div>
          </div>

          <div class="top-info-line flex flex-wrap">
            <a :href="`mailto:${customerInfo.email}`">{{ customerInfo.email }}</a>
          </div>

          <div class="social-buttons-wrapper full-width flex justify-content-around">
            <button class="social-button very-small-margin btn-sm" :disabled="!customerInfo.photo" @click="$emit('showCustomerPhoto')">
              <svg  viewBox="0 0 512 512" width="20px" fill="#fff">
                <g><path d="m482 135.849h-99.796l-21.746-78.695c-1.797-6.502-7.713-11.005-14.458-11.005h-179.9c-6.743 0-12.657 4.499-14.456 10.998l-21.79 78.703h-9.486v-45c0-8.284-6.716-15-15-15h-59.368c-8.284 0-15 6.716-15 15v45h-1c-16.542 0-30 13.458-30 30v270c0 16.542 13.458 30 30 30 .93 0 450.76.004 452 0 16.542 0 30-13.458 30-30v-270c0-16.543-13.458-30.001-30-30.001zm0 30v30h-83.215l-8.29-30zm-238.605 270c-68.9-6.38-123.027-64.503-123.027-135.041 0-74.788 60.844-135.631 135.632-135.631s135.632 60.844 135.632 135.631c0 70.537-54.127 128.661-123.027 135.041zm-65.884-359.7h157.072l26.795 96.967c-61.181-50.579-149.48-50.613-210.7-.048zm-116.511 29.7h29.368v30h-29.368zm60.548 60-8.306 30h-83.242v-30zm-91.548 270v-210h74.937c-6.959 27.702-14.569 43.583-14.569 74.959 0 55.659 27.596 104.994 69.825 135.041zm321.807 0c42.229-30.047 69.825-79.382 69.825-135.041 0-31.212-7.638-47.399-14.557-74.959h74.925v210z"/><path d="m256 195.708c-57.953 0-105.101 47.148-105.101 105.101s47.147 105.101 105.101 105.101 105.101-47.148 105.101-105.101-47.148-105.101-105.101-105.101zm0 180.201c-41.41 0-75.101-33.69-75.101-75.101s33.69-75.101 75.101-75.101 75.101 33.69 75.101 75.101-33.691 75.101-75.101 75.101z"/></g>
              </svg>
            </button>
            <a :href="facebookLink" target="_blank">
              <button class="social-button very-small-margin btn-sm" :disabled="!facebookLink">
                <svg viewBox="0 0 24 24" width="20px" fill="#fff">
                  <path d="m15.997 3.985h2.191v-3.816c-.378-.052-1.678-.169-3.192-.169-3.159 0-5.323 1.987-5.323 5.639v3.361h-3.486v4.266h3.486v10.734h4.274v-10.733h3.345l.531-4.266h-3.877v-2.939c.001-1.233.333-2.077 2.051-2.077z"/>
                </svg>
              </button>
            </a>
            <button class="social-button very-small-margin btn-sm" :disabled="!customerInfo.social || !customerInfo.social.instagram">
              <svg viewBox="0 0 512 512" width="20px" fill="#fff" xml:space="preserve">
                <g>
                  <g>
                    <path d="M352,0H160C71.648,0,0,71.648,0,160v192c0,88.352,71.648,160,160,160h192c88.352,0,160-71.648,160-160V160    C512,71.648,440.352,0,352,0z M464,352c0,61.76-50.24,112-112,112H160c-61.76,0-112-50.24-112-112V160C48,98.24,98.24,48,160,48    h192c61.76,0,112,50.24,112,112V352z"/>
                  </g>
                </g>
                <g>
                  <g>
                    <path d="M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M256,336    c-44.096,0-80-35.904-80-80c0-44.128,35.904-80,80-80s80,35.872,80,80C336,300.096,300.096,336,256,336z"/>
                  </g>
                </g>
                <g>
                  <g>
                    <circle cx="393.6" cy="118.4" r="17.056"/>
                  </g>
                </g>
              </svg>
            </button>
          </div>
        </div>

        <div class="top-info-item top-info-style flex-fill border border-light">
          <div class="top-info-line">
            <h3>Style</h3>
          </div>
          <div
            class="top-info-line flex"
            :class="{
              'bg-pink': customerInfo.style.classic < 3,
              'bg-light-yellow': customerInfo.style.classic == 3,
              'bg-light-green': customerInfo.style.classic > 3
            }"
          >
            <strong>
              Classic:
            </strong>
            <div class="margin-left-auto">
              {{ customerInfo.style.classic }}
            </div>
          </div>
          <div
            v-bind:class="{
              'bg-pink': customerInfo.style.simple < 3,
              'bg-light-yellow': customerInfo.style.simple == 3,
              'bg-light-green': customerInfo.style.simple > 3
            }"
            class="top-info-line flex"
          >
            <strong>
              Simple:
            </strong>
            <div class="margin-left-auto">
              {{ customerInfo.style.simple }}
            </div>
          </div>
          <div
            v-bind:class="{
              'bg-pink': customerInfo.style.feminine < 3,
              'bg-light-yellow': customerInfo.style.feminine == 3,
              'bg-light-green': customerInfo.style.feminine > 3
            }"
            class="top-info-line flex"
          >
            <strong>
              Feminine:
            </strong>
            <div class="margin-left-auto">
              {{ customerInfo.style.feminine }}
            </div>
          </div>
          <div
            v-bind:class="{
              'bg-pink': customerInfo.style.casual < 3,
              'bg-light-yellow': customerInfo.style.casual == 3,
              'bg-light-green': customerInfo.style.casual > 3
            }"
            class="top-info-line flex"
          >
            <strong>
              Causal:
            </strong>
            <div class="margin-left-auto">
              {{ customerInfo.style.casual }}
            </div>
          </div>
          <div
            v-bind:class="{
              'bg-pink': customerInfo.style.raw < 3,
              'bg-light-yellow': customerInfo.style.raw == 3,
              'bg-light-green': customerInfo.style.raw > 3
            }"
            class="top-info-line flex"
          >
            <strong>
              Raw:
            </strong>
            <div class="margin-left-auto">
              {{ customerInfo.style.raw }}
            </div>
          </div>
          <div
            v-bind:class="{
              'bg-pink': customerInfo.style.colorful < 3,
              'bg-light-yellow': customerInfo.style.colorful == 3,
              'bg-light-green': customerInfo.style.colorful > 3
            }"
            class="top-info-line flex"
          >
            <strong>
              Colorful:
            </strong>
            <div class="margin-left-auto">
              {{ customerInfo.style.colorful }}
            </div>
          </div>
          <div
            v-bind:class="{
              'bg-pink': customerInfo.style.boheme < 3,
              'bg-light-yellow': customerInfo.style.boheme == 3,
              'bg-light-green': customerInfo.style.boheme > 3
            }"
            class="top-info-line flex"
          >
            <strong>
              Boheme:
            </strong>
            <div class="margin-left-auto">
              {{ customerInfo.style.boheme }}
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap">
        <div class="top-info-item top-info-style flex-fill border border-light">
          <div class="full-width very-small-margin-top very-small-margin-top">
            <button
              class="rounded full-width"
              @click="showPrevOrders"
              :disabled="!hasPrevOrders"
            >
              Previous Orders
            </button>
          </div>

          <div class="full-width very-small-margin-top">
            <button
              class="rounded full-width"
              @click="$emit('showStylistComments')"
            >
              Stylist Comments
            </button>
          </div>
        </div>
        <div class="top-info-item top-info-style flex-fill border border-light">
          <div class="full-width very-small-margin-top">
            <button
              class="rounded full-width"
              @click="$emit('showCustomerComments')"
              :disabled="!hasCustomerComments"
            >
              Customer Comments
            </button>
          </div>

          <div class="full-width very-small-margin-top">
            <button
              class="rounded full-width"
              @click="$emit('showPreshippingFeedback')"
              :disabled="!hasPreshippingFeedback"
            >
              Sneak Peek Feedback
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="top-info-item top-info-size flex-fill border border-light">
      <div class="top-info-line">
        <h3>Size</h3>
      </div>
      <div class="top-info-line flex flex-wrap">
        <strong>
          Upper
        </strong>
        <div class="margin-left-auto">
          {{ customerInfo.sizes.upper }}
        </div>
      </div>
      <div class="top-info-line flex flex-wrap">
        <strong>
          Trousers
        </strong>
        <div class="margin-left-auto">
          {{ customerInfo.sizes.trousers }}
        </div>
      </div>
      <div class="top-info-line flex flex-wrap">
        <strong>
          Dress
        </strong>
        <div class="margin-left-auto">
          {{ customerInfo.sizes.dress }}
        </div>
      </div>
      <div class="top-info-line flex flex-wrap">
        <strong>
          Bra
        </strong>
        <div class="margin-left-auto">
          {{ customerInfo.sizes.bra }}
        </div>
      </div>

      <div class="very-small-margin no-padding" style="height: 0;">&nbsp;</div>
      <div class="top-info-line">
        <h3>Budget</h3>
      </div>

      <div class="top-info-line flex flex-wrap">
        <strong>
          Price top:
        </strong>
        <div class="margin-left-auto">
          {{ { regular_price: displayBudget(customerInfo.budget.tops), currency: customerInfo.locale.currency } | toCurrency }}
        </div>
      </div>
      <div class="top-info-line flex flex-wrap">
        <strong>
          Price dress:
        </strong>
        <div class="margin-left-auto">
          {{ { regular_price: displayBudget(customerInfo.budget.dresses), currency: customerInfo.locale.currency } | toCurrency }}
        </div>
      </div>
      <div class="top-info-line flex flex-wrap">
        <strong>
          Price pants:
        </strong>
        <div class="margin-left-auto">
          {{ { regular_price: displayBudget(customerInfo.budget.pants), currency: customerInfo.locale.currency } | toCurrency }}
        </div>
      </div>
      <div class="top-info-line flex flex-wrap">
        <strong>
          Price skirts:
        </strong>
        <div class="margin-left-auto">
          {{ { regular_price: displayBudget(customerInfo.budget.skirts), currency: customerInfo.locale.currency } | toCurrency }}
        </div>
      </div>
    </div>

    <div class="top-info-item top-info-need flex-fill border border-light">
      <div class="top-info-line">
        <h3>Need</h3>
      </div>
      <div
        v-bind:class="{
          'bg-pink': customerInfo.need.party == 'never',
          'bg-light-yellow': customerInfo.need.party == 'sometimes',
          'bg-light-green': customerInfo.need.party == 'often'
        }"
        class="top-info-line flex flex-wrap"
      >
        <strong>
          Party:
        </strong>
        <div class="margin-left-auto">
          {{ customerInfo.need.party }}
        </div>
      </div>
      <div
        v-bind:class="{
          'bg-pink': customerInfo.need.formal_work == 'never',
          'bg-light-yellow': customerInfo.need.formal_work == 'sometimes',
          'bg-light-green': customerInfo.need.formal_work == 'often'
        }"
        class="top-info-line flex flex-wrap"
      >
        <strong>
          Formal work:
        </strong>
        <div class="margin-left-auto">
          {{ customerInfo.need.formal_work }}
        </div>
      </div>
      <div
        v-bind:class="{
          'bg-pink': customerInfo.need.casual_work == 'never',
          'bg-light-yellow': customerInfo.need.casual_work == 'sometimes',
          'bg-light-green': customerInfo.need.casual_work == 'often'
        }"
        class="top-info-line flex flex-wrap"
      >
        <strong>
          Casual work:
        </strong>
        <div class="margin-left-auto">
          {{ customerInfo.need.casual_work }}
        </div>
      </div>
      <div
        v-bind:class="{
          'bg-pink': customerInfo.need.a_night_out == 'never',
          'bg-light-yellow': customerInfo.need.a_night_out == 'sometimes',
          'bg-light-green': customerInfo.need.a_night_out == 'often'
        }"
        class="top-info-line flex flex-wrap"
      >
        <strong>
          A night out:
        </strong>
        <div class="margin-left-auto">
          {{ customerInfo.need.a_night_out }}
        </div>
      </div>
      <div
        v-bind:class="{
          'bg-pink': customerInfo.need.casual_chill == 'never',
          'bg-light-yellow': customerInfo.need.casual_chill == 'sometimes',
          'bg-light-green': customerInfo.need.casual_chill == 'often'
        }"
        class="top-info-line flex flex-wrap"
      >
        <strong>
          Casual/Chill:
        </strong>
        <div class="margin-left-auto">
          {{ customerInfo.need.casual_chill }}
        </div>
      </div>
      <div class="top-info-line">
        <strong>
          <span>Highlight:</span>
        </strong>
        <div class="small-margin-left">
          <span v-for="(el, id) in customerInfo.highlights" :key="id">{{ el }}, </span>
        </div>
      </div>
      <div class="top-info-line">
        <strong>
          <span>Hide:</span>
        </strong>
        <div class="small-margin-left">
          <span v-for="(el, id) in customerInfo.cover" :key="id">{{ el }}, </span>
        </div>
      </div>
    </div>

    <div
      class="top-info-item top-info-dont-like flex-fill border border-light"
      style="position: relative;"
    >
      <div class="top-info-line">
        <h3>Don't Like</h3>
      </div>
      <div class="top-info-line flex flex-wrape">
        <strong>Upper: </strong>
        <div class="margin-left-auto">
          <span v-for="(el, id) in customerInfo.dislikes.upper" :key="id">{{ el }}, </span>
        </div>
      </div>
      <div class="top-info-line flex flex-wrape">
        <strong>Lower:</strong>
        <div class="margin-left-auto">
          <span v-for="(el, id) in customerInfo.dislikes.lower" :key="id">{{ el }}, </span>
        </div>
      </div>
      <div class="top-info-line flex flex-wrap">
        <strong>Colour:</strong>
        <div class="margin-left-auto">
          <span v-for="(el, id) in customerInfo.dislikes.colors" :key="id">{{ el }}, </span>
        </div>
      </div>
      <div class="top-info-line flex flex-wrap">
        <strong>Prints:</strong>
        <div class="margin-left-auto">
          <span v-for="(el, id) in customerInfo.dislikes.prints" :key="id">{{ el }}, </span>
        </div>
      </div>

      <div class="very-small-margin no-padding" style="height: 0;">&nbsp;</div>
      <div class="top-info-line">
        <h3>Fit</h3>
      </div>
      <div class="top-info-line flex flex-wrap">
        <strong>
          Body Type:
        </strong>
        <div class="margin-left-auto">
          {{ getBodyType(customerInfo.fit.body_type) }}
        </div>
      </div>
      <div class="top-info-line flex flex-wrap">
        <strong>
          Top:
        </strong>
        <div class="margin-left-auto">
          {{ customerInfo.fit.top }}
        </div>
      </div>
      <div class="top-info-line flex flex-wrap">
        <strong>
          Bottom:
        </strong>
        <div class="margin-left-auto">
          {{ customerInfo.fit.bottom }}
        </div>
      </div>
      <div class="top-info-line flex flex-wrap">
        <strong>
          Dress:
        </strong>
        <div class="margin-left-auto">
          {{ customerInfo.fit.dress }}
        </div>
      </div>
      <div class="top-info-line flex flex-wrap">
        <strong>
          Skirt:
        </strong>
        <div class="margin-left-auto">
          {{ customerInfo.fit.skirt }}
        </div>
      </div>

      <input type="checkbox" name="interaction-toggler" id="interaction-toggler">
      <label data-testid="interaction-toggler" for="interaction-toggler" class="interaction-toggler"></label>
      <div data-testid="interaction-wrapper" class="interaction-wrapper">
        <div class="small-padding">
          <div class="text-center bg-base white">
            <h3>CUSTOMER INTERACTION</h3>
          </div>
          <div style="very-small-padding flex">
            <div style="no-padding flex-basis">
              <div class="text-center border-light bg-light-pink border-pink">
                <div class="white bg-pink">
                  DURING CALL
                </div>
                <div class="small-margin flex justify-content-around">
                  <button data-testid="old-email-send" class="btn" @click="sendEmailWithStyles" ref="button-email">EMAIL<br />WITH STYLES</button>
                  <button data-testid="old-sms-send" class="btn" @click="sendSmsWithStyles" ref="button-sms">SMS<br />WITH STYLES</button>
                </div>
              </div>
            </div>
            <div style="no-padding flex-basis">
              <div class="text-center border-light bg-light-pink border-pink">
                <div class="white bg-pink">
                  DURING CALL
                </div>
                <div class="small-margin flex justify-content-around">
                  <button class="btn" @click="$emit('sendOldSurveyPSPreCheck')" ref="button-preshipping">Sneak Peek<br />FEEDBACK</button>
                  <button class="btn" @click="$emit('rescheduleCall')" :disabled="!customerInfo.scheduledCall" ref="button-reschedule">RESCHEDULE<br />CALL</button>
                  <button class="btn" @click="sendPreshippingMissedMessage" ref="button-preshipping-missed">MISSED CALL <br>SP</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="notify-wrapper flex align-center" v-if="notifyShow">
      <SvgFile name="error" v-if="notify.status === 'error'" color="#FE0006" />
      <SvgFile name="ok" v-if="notify.status === 'success'" color="#4DAA00" />
      <h2 class="no-margin very-small-margin-left" :class="notify.status">
        {{ notify.message }}
      </h2>
    </div>

    <modal name="confirmSecondPSModal" v-if="showSecondPSConfirmModal" @close="showSecondPSConfirmModal = false" :modal-width="380"
    >
      <div v-click-outside="() => { stockWarningModalShow = false;}">
        <ConfirmSecondPSModal @close="showSecondPSConfirmModal = false" @confirmSendSecondPS="confirmSendSecondPS" />
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from 'vue'
import ConfirmSecondPSModal from '@/components/styling-process/ConfirmSecondPSModal.vue'

let loader
export default {
  name: 'ProcessTopBar',
  components: {
    ConfirmSecondPSModal
  },
  props: {
    customerInfo: {
      type: Object,
      default: null
    },
    hasPreshippingFeedback: {
      type: Boolean,
      default: false
    },
    hasPrevOrders: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      userID: '',
      prevOrders: [],
      commentsStyleApplication: '',
      notifyShow: false,
      notify: {
        status: 'success',
        message: 'Hello World'
      },
      clickedButton: '',
      dashboardBaseUrl: process.env.VUE_APP_WEBSITE_URL,
      showSecondPSConfirmModal: false
    }
  },
  computed: {
    computedSizeBraCM () {
      const braSize = this.customerInfo.sizeBraCM

      if (braSize) {
        if (
          braSize.substr(braSize.length - 2, braSize.length).toLowerCase() ==
            'cm'
        ) {
          return braSize.substr(0, braSize.length - 2)
        }
      }
      return braSize
    },
    hasStylistComments () {
      return this.customerInfo.stylistComments ? this.customerInfo.stylistComments.length > 0 : false
    },
    hasCustomerComments () {
      return this.customerInfo.customerComments ? this.customerInfo.customerComments.length > 0 : false
    },
    facebookLink () {
      return this.customerInfo.social ? this.customerInfo.social.facebook : null
    }
  },
  methods: {
    updateOrderWishes () {
      console.log('updateOrderWishes')
    },
    showPrevOrders () {
      this.$emit('showPrevModal', this.prevOrders)
    },
    displayBudget (price) {
      return price[1] ? price[0] + ' - ' + price[1] : price[0] + '+'
    },
    sendEmailWithStyles () {
      Vue.api.get(`order/${this.$route.query.id}/email-with-styles`, {}, {
        before: () => this.clickedButton = 'email',
        always: () => this.clickedButton = '',
        callback: () => {
          this.showNotify({ status: 'success', message: 'Email sent with styles' })
          setTimeout(() => {
            window.open(`${this.dashboardBaseUrl}/styling-ordre/?orderID=${this.$route.query.id}&key=${this.$route.query.key}`, '_blank')
          }, 500)
        },
        error: error => {
          this.showNotify({ status: 'error', message: error.data.message })
        }
      })
    },
    sendSmsWithStyles () {
      Vue.api.get(`order/${this.$route.query.id}/sms-with-styles`, {}, {
        before: () => this.clickedButton = 'sms',
        always: () => this.clickedButton = '',
        callback: () => {
          this.showNotify({ status: 'success', message: 'SMS sent with styles' })
          setTimeout(() => {
            window.open(`${this.dashboardBaseUrl}/styling-ordre/?orderID=${this.$route.query.id}&key=${this.$route.query.key}`, '_blank')
          }, 500)
        },
        error: error => {
          this.showNotify({ status: 'error', message: error.data.message })
        }
      })
    },
    sendPreshippingMissedMessage () {
      if (confirm('This button shall only be used, if customer did not pick up the phone. Is this the case?')) {
        Vue.api.post(`order/${this.$route.query.id}/send-preshipping-missed`, {}, {
          before: () => this.clickedButton = 'preshipping-missed',
          always: () => this.clickedButton = '',
          callback: () => {
            this.showNotify({ status: 'success', message: 'Sneak Peek text message sent' })
          },
          error: error => {
            this.showNotify({ status: 'error', message: error.data.message })
          }
        })
      }
    },

    showNotify (notify) {
      this.notify = notify
      this.notifyShow = true
      setTimeout(() => {
        this.notify = { status: '', message: '' }
        this.notifyShow = false
      }, 3000)
    },
    getBodyType (bodyType) {
      switch (bodyType) {
        case '1':
          return 'Inverted Triangle'
        case '2':
          return 'Pear'
        case '3':
          return 'Apple'
        case '4':
          return 'Hourglass'
        case '5':
          return 'Rectangle'
        default:
          return '??'
      }
    }
  },

  watch: {
    clickedButton (newVal, oldVal) {
      if (newVal) {
        this.$refs['button-' + newVal].disabled = true
      } else {
        this.$refs['button-' + oldVal].disabled = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../styles/variables.less';
.top-info-personal {
  max-width: 200px;
}

h3 {
  margin-top: 10px;
  margin-bottom: 10px;
}

.top-info-item {
  font-size: 1.1em;
  padding: 0;
  min-width: 120px;
  margin-top: 0;
}
.top-info-line {
  background-color: #fddfdb;
  margin-top: 3px;
  padding: 3px 10px 3px 5px;
  overflow: hidden;
  white-space: normal
}

.picture-btn {
  background: @grey;

  &.active {
    background: @base-color;
  }
}

.bg-pink {
  background-color: #f28f86;
}
.bg-light-pink {
  background-color: #fbebe5;
}
.border-pink {
  border: 1px solid #f28f86;
}

input[type=checkbox] {
  display: none;
}
.interaction-toggler {
  background-color: #fff;
  width: 45px;
  height: 45px;
  box-sizing: border-box;
  padding: 7px 7px;
  border-radius: 5px;
  box-shadow: 5px 5px 15px 5px #000000;
  position: absolute;
  bottom: 5px;
  right: 0px;

  &::after {
    content: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAHdElNRQfkAhsOIAu0EaDqAAAARElEQVRIx+2SwQ0AEBRDHwZgFfafgQvjCCuIH4lDX889tHkgHIlMuGxPGgyWId0bFyxHpBgm1If3imNkokz8A5koEwE2HRxuCPy2TQAAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjAtMDItMjdUMTQ6MzI6MTErMDA6MDD7kT5HAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIwLTAyLTI3VDE0OjMyOjExKzAwOjAwisyG+wAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII=);
  }
}

.interaction-wrapper {
  position: absolute;
  bottom: 40px;
  right: -10px;
  background-color: #fff;
  z-index: 1000;
  border-radius: 5px;
  max-height: 0;
  overflow: hidden;
  transition: all .5s ease;
}

#interaction-toggler:checked ~ .interaction-wrapper {
  max-height: 1000px;
  // padding: 10px;
  // border: 2px solid #000;
  // box-shadow: 5px 5px 15px 5px rgba(0, 0, 0, .3);
}

#interaction-toggler:checked ~ .interaction-toggler::after {
  content: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAHdElNRQfkAhsOJgPskI9eAAAApUlEQVRIx72VTQ5CIQyEv3g6A4mnfHo3hb28FW5MDHk/tJ1E1jMDtNMOPKgkIidRWaDQaWQ3PdPoPCHRAhL5y0oAV950Vm5m+obhk9hF2yUOkTaJU9RcYoo4B5jeeAwyV2kf6OrTFux2ykjwG20ghejwc3tkUoZXTG6/RJT/8gWxiGIbRSOJVhaHSRxncaGIK01cquJaF4NFjrYqhesL7pRwvBeWDyB4zna8LIyAAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIwLTAyLTI3VDE0OjM4OjAzKzAwOjAwt4a/OQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMC0wMi0yN1QxNDozODowMyswMDowMMbbB4UAAAAZdEVYdFNvZnR3YXJlAHd3dy5pbmtzY2FwZS5vcmeb7jwaAAAAAElFTkSuQmCC
)
}

.notify-wrapper {
  position: absolute;
  right: 0;
  top: 20px;
  background: rgba(255, 255, 255, 0.6);
  padding: 10px;
  border-radius: 5px;
}
</style>
